import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'SIGN_SYMPTOM';

export default createListReducer(TEMPLATE_NAME);
